export default __webpack_public_path__ + "static/media/catalog-filled.2589c972.svg";